import { FilterMatchMode } from "primereact/api"

export class ParametroEmpresa {
    model = {
        id: { value: null, export: false },
        tipo: {
            value: '', export: true, header: 'Tipo', required: 'Tipo es requerido', maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 250, min: 4, table: true, matchMode: FilterMatchMode.CONTAINS,
            filterField: 'nombre', filter: true, sort: true, filterPlaceholder: 'Buscar',
            headerStyle: { width: '15%', minWidth: '15rem' }
        },
        valor: {
            value: '', export: true, header: 'Sigla', required: false, maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres', max: 50, min: 4, table: false,
        },
        contenido: {
            value: '', export: true, header: 'Valor', required: 'Valor es requerido', maxLength: 'Máximo 500 caracteres',
            minLength: 'Mínimo 1 caracteres', max: 500, min: 1, table: true,
        },
        empresa: {
            header: 'Empresa', value: '', required: 'Empresa es requerido', optionLabel: 'empresa', export: true, table: false
        },
        estado: {
            header: 'Activar', value: {cat_id: false, nombre: 'NO'}, required: false, optionLabel: 'tipo_proceso', export: true, table: true,
        },
        periocidad: {header: 'Periocidad', value: [], required: false, optionLabel: 'nombre', export: false, table: false},
    }

    optionLabel = 'nombre'
}
